import ProductSection from './ProductSection';

export default class FeaturedProduct extends ProductSection {
  get isFeaturedProduct() {
    return true;
  }
}
